<template>
  <div id="main">
    <div class="hd">
      <div class="hd-main">
        <div class="ep-hd-info">
          <div class="ep-logo">
            <img
              src="../assets/img/logo.png"
              alt="sony"
            />
          </div>
          <div class="ep-order-status">
            <h1>维修单支付</h1>
          </div>
        </div>
      </div>
    </div>
    <div class="cart_t">
      <div class="w1210">
        <div class="cart_top clearfix">
          <p class="c_title step3">
            {{ orderStatus === true ? "完成订单" : errMsg }}
          </p>
        </div>
      </div>
    </div>
    <div class="shop_cont">
      <!--<div class=" w1210 xxts">! 温馨提示：收到货物后15天内，系统自动将相应成长值发放到您的会员账户</div>-->
      <div class="w1210 pad35 mbottom mt15">
        <div class="w1140">
          <div class="finish_m bbtom clearfix">
            <div
              class="lstat_i"
              v-show="orderStatus"
            >
              <img src="../assets/img/s.png" />
            </div>
            <div
              class="lstat_i"
              v-show="!orderStatus"
            >
              <img src="../assets/img/f.png" />
            </div>
            <div class="fl_p">
              <p class="onum">订单号：{{ serviceSheetNo }}</p>
              <p
                class="pstat"
                v-show="orderStatus"
              >
                您已成功付款：<span>{{ total }}元</span>
              </p>
              <!--<p class="psinf">-->
              <!--寄送至： 上海 上海市 浦东新区 周家渡街道 浦东新区 德州路56弄1号1101室 冯毅 收 13748562258-->
              <!--</p>-->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from "../common/utils/api";
import http from "axios";
export default {
  components: {},
  data() {
    // out_trade_no
    return {
      orderStatus: null,
      serviceSheetNo: "",
      total: "",
      orderSn: "",
      outSn: "",
      clientSn: "",
      storeSn: "",
      errMsg: "", //支付失败信息
    };
  },
  methods: {
    //获取相关参数
    getParams() {
      let params = localStorage.getItem("wxpayParams");
      let parsePar = JSON.parse(params);
      this.total = parsePar.total;
      this.orderSn = parsePar.orderSn;
      this.outSn = parsePar.outSn;
      this.serviceSheetNo = parsePar.serviceSheetNo;
      this.clientSn = parsePar.clientSn;
      this.storeSn = parsePar.storeSn;
      this.queryOrder();
    },
    //查询支付状态
    queryOrder() {
      let url = api.reservation.queryOrder();
      let params = {
        cusid: this.storeSn,
        reqsn: this.orderSn
      };
      http.post(url, params).then((res) => {
        console.log(res.data);
        let status = res.data.data.trxstatus;
        if (status === '0000') {
          this.orderStatus = true;
        } else {
          this.orderStatus = false;
          this.errMsg = res.data.data.errmsg
        }
      });
    },
  },
  created() { },
  mounted: function () {
    //移出默认添加的头部和底部
    var header = document.getElementById("getHeader");
    var footer = document.getElementById("getFooter");
    if (header != null) {
      header.remove();
    }
    if (footer != null) {
      footer.remove();
    }

    this.getParams();
  },
};
</script>
<style scoped>
@import url("../assets/css/style.css");
@import url("../assets/css/layout.css");
@import url("../assets/css/editcart.css");
@import url("../assets/css/finish.css");
.hd {
  height: 70px;
  color: #fff;
  background-color: #000;
}
.hd-main {
  width: 1080px;
  height: 100%;
  margin: 0 auto;
  *zoom: 1;
}
.hd-main:after,
.hd-main:before {
  content: "";
  display: table;
}
.hd-main:after {
  clear: both;
}
.ep-hd-info {
  float: left;
  height: 100%;
  font-size: 0;
}
.ep-logo,
.ep-order-status {
  float: left;
}
.ep-logo {
  padding-top: 25px;
}
.ep-logo a {
  display: block;
}
.ep-logo img {
  width: 114px;
}
.ep-order-status {
  margin: 23px 0 0 20px;
  padding-left: 20px;
  border-left: 1px solid #f0f0f0;
  line-height: 26px;
  font-size: 16px;
}
.ep-order-status h1 {
  font-size: 16px;
  font-weight: 700;
}
</style>
